import { render, staticRenderFns } from "./image-capture.vue?vue&type=template&id=a142f482&"
import script from "./image-capture.vue?vue&type=script&lang=js&"
export * from "./image-capture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "image-capture.vue"
export default component.exports